export const WORKING_TIME_LABEL_FORMAT = 'constraintUtilization.workingTime.label.common.text';
export const CAPACITY_LABEL_FORMAT = 'constraintUtilization.capacity.label.common.text';
export const PERCENT_LABEL = 'constraintUtilization.common.label.percent';
